document.addEventListener('DOMContentLoaded', function () {
  const swatches = document.querySelectorAll('ul.variantcolor li.color-swatch');
  const hiddenInput = document.getElementById('selected-variant-color');
  
  let activeSwatch = document.querySelector('ul.variantcolor li.color-swatch.active');
  let selectedColor = activeSwatch ? activeSwatch.dataset.color : '';

  if (swatches.length > 0) {
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        swatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');
        
        selectedColor = this.dataset.color;
        if (hiddenInput) {
          hiddenInput.value = selectedColor;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function refreshCartUIElements() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
        const bubbleHTMLs = document.querySelectorAll('.cart-count-bubble');

        bubbleHTMLs.forEach(bubble => {
          bubble.textContent = cart.item_count;
          if (cart.item_count === 0) {
            bubble.classList.add('hidden');
          } else {
            bubble.classList.remove('hidden');
          }
        });


        if (cartDrawer) {
          if (cart.item_count === 0) {
            cartDrawer.removeAttribute('open');
            cartDrawer.classList.add('is-empty');
            document.body.classList.remove('overflow-hidden');
            if (typeof cartDrawer.close === 'function') cartDrawer.close();
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }
      }).catch(err => console.error("Sync error:", err));
  }

  document.addEventListener('cart:updated', function() {
    setTimeout(refreshCartUIElements, 300);
  });
  
  document.documentElement.addEventListener('cart:refresh', function() {
    setTimeout(refreshCartUIElements, 300);
  });

  const bodyEl = document.body;
  bodyEl.addEventListener('click', function(e) {
    if (
      e.target.closest('[name="plus"]') || 
      e.target.closest('[name="minus"]') || 
      e.target.closest('.cart-remove-button') || 
      e.target.closest('cart-remove-button') || 
      e.target.closest('button[id^="Remove-"]')
    ) {
      setTimeout(refreshCartUIElements, 800);
    }
  });

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let url = args[0];
    let options = args[1] || {};
    let urlString = (typeof url === 'string') ? url : (url instanceof Request ? url.url : '');

    // Sirf /cart/add.js par hi property attach karenge, baki kisi request ko chhedenge nahi
    if (urlString.includes('/cart/add') && selectedColor) {
      if (options.body instanceof FormData) {
        options.body.set('properties[Color]', selectedColor);
      } else if (typeof options.body === 'string') {
        try {
          const body = JSON.parse(options.body);
          if (!body.properties) body.properties = {};
          body.properties.Color = selectedColor;
          options.body = JSON.stringify(body);
        } catch (e) {}
      } else if (options.body instanceof URLSearchParams) {
        options.body.set('properties[Color]', selectedColor);
      }
    }

    return originalFetch.apply(this, args).then(response => {
      // Agar product safely add ho gaya toh drawer open aur classes toggle trigger karein
      if (urlString.includes('/cart/add') && response.ok) {
        setTimeout(() => {
          refreshCartUIElements();
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.setAttribute('open', '');
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        }, 300);
      }
      return response;
    });
  };
});


document.addEventListener('DOMContentLoaded', function () {
  const sizeSwatches = document.querySelectorAll('ul.variantsize li.size-swatch');
  const sizeHiddenInput = document.getElementById('selected-variant-size');
  
  let activeSizeSwatch = document.querySelector('ul.variantsize li.size-swatch.active');
  let selectedSize = activeSizeSwatch ? activeSizeSwatch.dataset.size : '';

  // 1. Size Swatches Click Event Handling
  if (sizeSwatches.length > 0) {
    sizeSwatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        sizeSwatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');
        
        selectedSize = this.dataset.size;
        if (sizeHiddenInput) {
          sizeHiddenInput.value = selectedSize;
          sizeHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // 2. Cart UI Sync (Icon Bubble & Empty Space Fix)
  function refreshCartSizeUIElements() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
        const bubbleHTMLs = document.querySelectorAll('.cart-count-bubble');

        bubbleHTMLs.forEach(bubble => {
          bubble.textContent = cart.item_count;
          if (cart.item_count === 0) {
            bubble.classList.add('hidden');
          } else {
            bubble.classList.remove('hidden');
          }
        });

        if (cartDrawer) {
          if (cart.item_count === 0) {
            cartDrawer.removeAttribute('open');
            cartDrawer.classList.add('is-empty');
            document.body.classList.remove('overflow-hidden');
            if (typeof cartDrawer.close === 'function') cartDrawer.close();
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }
      }).catch(err => console.error("Size Cart Sync error:", err));
  }

  // Shopify Theme Dynamic Events Tracking
  document.addEventListener('cart:updated', function() {
    setTimeout(refreshCartSizeUIElements, 300);
  });
  
  document.documentElement.addEventListener('cart:refresh', function() {
    setTimeout(refreshCartSizeUIElements, 300);
  });

  // Drawer inside clicks tracking (Plus/Minus/Remove)
  const bodyEl = document.body;
  bodyEl.addEventListener('click', function(e) {
    if (
      e.target.closest('[name="plus"]') || 
      e.target.closest('[name="minus"]') || 
      e.target.closest('.cart-remove-button') || 
      e.target.closest('cart-remove-button') || 
      e.target.closest('button[id^="Remove-"]')
    ) {
      setTimeout(refreshCartSizeUIElements, 800);
    }
  });

  // 3. Safe Add To Cart Fetch Logic (Strictly URL and Options array management)
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let url = args[0];
    let options = args[1] || {};
    let urlString = (typeof url === 'string') ? url : (url instanceof Request ? url.url : '');

    // Sirf Add To Cart call par properties attach hogi, delete calls block nahi hongi
    if (urlString.includes('/cart/add') && selectedSize) {
      if (options.body instanceof FormData) {
        options.body.set('properties[Size]', selectedSize);
      } else if (typeof options.body === 'string') {
        try {
          const body = JSON.parse(options.body);
          if (!body.properties) body.properties = {};
          body.properties.Size = selectedSize;
          options.body = JSON.stringify(body);
        } catch (e) {}
      } else if (options.body instanceof URLSearchParams) {
        options.body.set('properties[Size]', selectedSize);
      }
    }

    return originalFetch.apply(this, args).then(response => {
      if (urlString.includes('/cart/add') && response.ok) {
        setTimeout(() => {
          refreshCartSizeUIElements();
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.setAttribute('open', '');
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        }, 300);
      }
      return response;
    });
  };
});


document.addEventListener('DOMContentLoaded', function () {
  const placementSwatches = document.querySelectorAll('ul.variantplacement li.placement-swatch');
  const placementHiddenInput = document.getElementById('selected-print-placement');
  
  let activePlacementSwatch = document.querySelector('ul.variantplacement li.placement-swatch.active');
  let selectedPlacement = activePlacementSwatch ? activePlacementSwatch.dataset.placement : 'Front';

  // 1. Clicks Handling (Border Toggle)
  if (placementSwatches.length > 0) {
    placementSwatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        placementSwatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');
        
        selectedPlacement = this.dataset.placement;
        if (placementHiddenInput) {
          placementHiddenInput.value = selectedPlacement;
          placementHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // 2. Dynamic Cart Sync Handler (No Space Bug / Refresh Bug)
  function refreshPlacementCartUI() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
        const bubbleHTMLs = document.querySelectorAll('.cart-count-bubble');

        bubbleHTMLs.forEach(bubble => {
          bubble.textContent = cart.item_count;
          if (cart.item_count === 0) {
            bubble.classList.add('hidden');
          } else {
            bubble.classList.remove('hidden');
          }
        });

        if (cartDrawer) {
          if (cart.item_count === 0) {
            cartDrawer.removeAttribute('open');
            cartDrawer.classList.add('is-empty');
            document.body.classList.remove('overflow-hidden');
            if (typeof cartDrawer.close === 'function') cartDrawer.close();
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }
      }).catch(err => console.error("Placement Sync error:", err));
  }

  // Shopify Standard Theme Events Sync
  document.addEventListener('cart:updated', function() {
    setTimeout(refreshPlacementCartUI, 300);
  });
  document.documentElement.addEventListener('cart:refresh', function() {
    setTimeout(refreshPlacementCartUI, 300);
  });

  // Track Drawer actions safely (Plus/Minus/Remove)
  document.body.addEventListener('click', function(e) {
    if (
      e.target.closest('[name="plus"]') || 
      e.target.closest('[name="minus"]') || 
      e.target.closest('.cart-remove-button') || 
      e.target.closest('cart-remove-button') || 
      e.target.closest('button[id^="Remove-"]')
    ) {
      setTimeout(refreshPlacementCartUI, 800);
    }
  });

  // 3. Isolated Object Safe Add To Cart Injection
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let url = args[0];
    let options = args[1] || {};
    let urlString = (typeof url === 'string') ? url : (url instanceof Request ? url.url : '');

    // Sirf custom add operation ko block kiya gaya hai, delete hooks change calls safe hain
    if (urlString.includes('/cart/add') && selectedPlacement) {
      if (options.body instanceof FormData) {
        options.body.set('properties[Print Placement]', selectedPlacement);
      } else if (typeof options.body === 'string') {
        try {
          const body = JSON.parse(options.body);
          if (!body.properties) body.properties = {};
          body.properties['Print Placement'] = selectedPlacement;
          options.body = JSON.stringify(body);
        } catch (e) {}
      } else if (options.body instanceof URLSearchParams) {
        options.body.set('properties[Print Placement]', selectedPlacement);
      }
    }

    return originalFetch.apply(this, args).then(response => {
      if (urlString.includes('/cart/add') && response.ok) {
        setTimeout(() => {
          refreshPlacementCartUI();
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.setAttribute('open', '');
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        }, 300);
      }
      return response;
    });
  };
});


document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.design-tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');
  const galleryCards = document.querySelectorAll('.design-gallery-card');
  const fileInput = document.getElementById('custom-artwork-file');
  const statusText = document.getElementById('upload-status-text');
  const textBox = document.getElementById('custom-design-text-box');

  // Master Control: Jo raw input values ko sync aur validate rakhega
  function enforceSingleTabProperties() {
    const mainOptionInput = document.getElementById('selected-design-option');
    const designValueInput = document.getElementById('selected-design-value');
    const designImageInput = document.getElementById('selected-design-image-url'); // Image input target field
    const artworkNameInput = document.getElementById('uploaded-artwork-name');
    const customTextInput = document.getElementById('custom-design-text-val');

    let activeTab = document.querySelector('.design-tab-btn.active');
    if (!activeTab) return;

    // Strict key verification by checking 'data-tab-name' parameter instead of raw labels
    let activeTabKey = activeTab.dataset.tabName ? activeTab.dataset.tabName.toLowerCase() : '';
    let displayTitle = activeTab.querySelector('span').textContent.trim();
    
    if (mainOptionInput) mainOptionInput.value = displayTitle;

    // Tab A Validation (Choose from designs)
 if (activeTabKey === 'designs') {
  if (designValueInput) {
    designValueInput.removeAttribute('disabled');

    let activeCard = document.querySelector(
      '.design-gallery-card.active'
    );

    designValueInput.value = activeCard
      ? activeCard.dataset.designName
      : '';
  }

 
  if (designImageInput) {
    designImageInput.setAttribute('disabled', 'true');
    designImageInput.value = '';
  }

  if (artworkNameInput) {
    artworkNameInput.setAttribute('disabled', 'true');
    artworkNameInput.value = '';
  }

  if (customTextInput) {
    customTextInput.setAttribute('disabled', 'true');
    customTextInput.value = '';
  }
}
    // Tab B Validation (Upload artwork)
    // Tab B Validation (Upload artwork) - Updated for Live Link Link
    else if (activeTabKey === 'artwork') {
      if (designValueInput) { designValueInput.setAttribute('disabled', 'true'); designValueInput.value = ""; }
      if (designImageInput) { designImageInput.setAttribute('disabled', 'true'); designImageInput.value = ""; }
      if (artworkNameInput) {
        artworkNameInput.removeAttribute('disabled');
        // File name ki jagah customer ka pure image resource link data url save hoga
        if (fileInput && fileInput.files && fileInput.files[0]) {
          const reader = new FileReader();
          reader.onload = function(e) {
            artworkNameInput.value = e.target.result; // Direct image base64 data string pass logic
          }
          reader.readAsDataURL(fileInput.files[0]);
        } else {
          artworkNameInput.value = "";
        }
      }
      if (customTextInput) { customTextInput.setAttribute('disabled', 'true'); customTextInput.value = ""; }
    }

    // Tab C Validation (Add text)
    else if (activeTabKey === 'text') {
      if (designValueInput) { designValueInput.setAttribute('disabled', 'true'); designValueInput.value = ""; }
      if (designImageInput) { designImageInput.setAttribute('disabled', 'true'); designImageInput.value = ""; }
      if (artworkNameInput) { artworkNameInput.setAttribute('disabled', 'true'); artworkNameInput.value = ""; }
      if (customTextInput) {
        customTextInput.removeAttribute('disabled');
        customTextInput.value = textBox ? textBox.value.trim() : '';
      }
    }
  }

  setTimeout(enforceSingleTabProperties, 300);

  // Tabs Clicking Toggle Hook
  if (tabButtons.length > 0) {
    tabButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        tabButtons.forEach(b => b.classList.remove('active'));
        tabPanels.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        const targetId = this.dataset.target;
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) targetPanel.classList.add('active');
        enforceSingleTabProperties();
      });
    });
  }

  // Cards Selection Engine
  if (galleryCards.length > 0) {
    galleryCards.forEach(card => {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        galleryCards.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        enforceSingleTabProperties();
      });
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      if (this.files && this.files[0]) {
        if (statusText) statusText.textContent = "✅ " + this.files[0].name;
        enforceSingleTabProperties();
      }
    });
  }

  if (textBox) {
    textBox.addEventListener('input', enforceSingleTabProperties);
  }

  // Dynamic AJAX cart update logic
  function refreshActiveCartSystemLayout() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
        const bubbleHTMLs = document.querySelectorAll('.cart-count-bubble');
        bubbleHTMLs.forEach(bubble => {
          bubble.textContent = cart.item_count;
          if (cart.item_count === 0) bubble.classList.add('hidden');
          else bubble.classList.remove('hidden');
        });
        if (cartDrawer) {
          if (cart.item_count === 0) {
            cartDrawer.removeAttribute('open');
            cartDrawer.classList.add('is-empty');
            if (typeof cartDrawer.close === 'function') cartDrawer.close();
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }
      }).catch(err => console.error("Sync Error:", err));
  }

  document.addEventListener('cart:updated', function() { setTimeout(refreshActiveCartSystemLayout, 300); });
  document.documentElement.addEventListener('cart:refresh', function() { setTimeout(refreshActiveCartSystemLayout, 300); });

  // Parameter Interceptor Array Filters - Updated with Binary File Upload System
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let url = args[0];
    let options = args[1] || {};
    let urlString = (typeof url === 'string') ? url : (url instanceof Request ? url.url : '');

    if (urlString.includes('/cart/add')) {
      enforceSingleTabProperties();
      
      const mainOptionInput = document.getElementById('selected-design-option');
      const designImageInput = document.getElementById('selected-design-image-url'); // Image field variable reference
      let activeTab = document.querySelector('.design-tab-btn.active');
      let activeTabKey = activeTab ? activeTab.dataset.tabName.toLowerCase() : '';

      if (options.body instanceof FormData) {
        if (mainOptionInput) options.body.set('properties[Design Option]', mainOptionInput.value);
        
        if (activeTabKey === 'text') {
          options.body.set('properties[Custom Text]', textBox ? textBox.value.trim() : '');
          options.body.delete('properties[Selected Design]');
          options.body.delete('properties[_DesignImage]'); // Remove image if on Text tab
          options.body.delete('properties[Uploaded Artwork]');
        }
        else if (activeTabKey === 'artwork') {
          // FIX LOGIC: String name ki jagah direct input file element ka dynamic reference handle karna
          if (fileInput && fileInput.files && fileInput.files[0]) {
            options.body.set('properties[Uploaded Artwork]', fileInput.files[0]); // Pure binary asset handle push
          } else {
            options.body.set('properties[Uploaded Artwork]', '');
          }
          options.body.delete('properties[Selected Design]');
          options.body.delete('properties[_DesignImage]'); // Remove image if on Upload tab
          options.body.delete('properties[Custom Text]');
        }
        else if (activeTabKey === 'designs') {
          let activeCard = document.querySelector('.design-gallery-card.active');
          options.body.set('properties[Selected Design]', activeCard ? activeCard.dataset.designName : '');
          
          // Agar image URL generate hua hai, toh payload object me inject karna
          if (designImageInput && designImageInput.value) {
            options.body.set('properties[_DesignImage]', designImageInput.value);
          }
          options.body.delete('properties[Uploaded Artwork]');
          options.body.delete('properties[Custom Text]');
        }
      }
    }

    return originalFetch.apply(this, args).then(response => {
      if (urlString.includes('/cart/add') && response.ok) {
        setTimeout(() => {
          // Aapki theme ka original screen update layout standard handle framework function
          if (typeof refreshActiveCartSystemLayout === 'function') {
            refreshActiveCartSystemLayout();
          } else if (typeof refreshCartUIElements === 'function') {
            refreshCartUIElements();
          }
          
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.setAttribute('open', '');
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        }, 300);
      }
      return response;
    });
  };
});



const instructionTextBox = document.getElementById('custom-additional-instructions-box');
const instructionCharCounter = document.getElementById('instruction-char-counter');
const instructionHiddenVal = document.getElementById('custom-instruction-hidden-val');

if (instructionTextBox) {
  instructionTextBox.addEventListener('input', function() {
    let currentLength = this.value.length;
    if (instructionCharCounter) instructionCharCounter.textContent = `${currentLength}/500 characters`;
    if (instructionHiddenVal) instructionHiddenVal.value = this.value.trim();
  });
}



document.addEventListener('DOMContentLoaded', function () {
  const instructionTextBox = document.getElementById('custom-additional-instructions-box');
  const instructionCharCounter = document.getElementById('instruction-char-counter');
  const instructionHiddenVal = document.getElementById('custom-instruction-hidden-val');

  // 1. Real-Time Character Counter and Hidden Value Sync
  if (instructionTextBox) {
    instructionTextBox.addEventListener('input', function() {
      let currentLength = this.value.length;
      if (instructionCharCounter) {
        instructionCharCounter.textContent = `${currentLength}/500 characters`;
      }
      if (instructionHiddenVal) {
        instructionHiddenVal.value = this.value.trim();
        // Trigger change event for theme compatibility
        instructionHiddenVal.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // 2. Safe Fetch Interceptor (Sirf tabhi data add karega jab text box me kuch likha ho)
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let url = args[0];
    let options = args[1] || {};
    let urlString = (typeof url === 'string') ? url : (url instanceof Request ? url.url : '');

    if (urlString.includes('/cart/add')) {
      const latestInstruction = document.getElementById('custom-instruction-hidden-val');
      const instructionText = latestInstruction ? latestInstruction.value.trim() : '';

      if (options.body instanceof FormData) {
        if (instructionText !== "") {
          options.body.set('properties[Additional Instructions]', instructionText);
        } else {
          options.body.delete('properties[Additional Instructions]');
        }
      } else if (typeof options.body === 'string') {
        try {
          const body = JSON.parse(options.body);
          if (!body.properties) body.properties = {};
          
          if (instructionText !== "") {
            body.properties['Additional Instructions'] = instructionText;
          } else {
            delete body.properties['Additional Instructions'];
          }
          options.body = JSON.stringify(body);
        } catch (e) {}
      } else if (options.body instanceof URLSearchParams) {
        if (instructionText !== "") {
          options.body.set('properties[Additional Instructions]', instructionText);
        } else {
          options.body.delete('properties[Additional Instructions]');
        }
      }
    }

    return originalFetch.apply(this, args);
  };
});



document.addEventListener('DOMContentLoaded', function () {
  const designOverlayContainer = document.getElementById('preview-dynamic-design-overlay');
  const overlayPlaceholder = document.getElementById('overlay-content-placeholder');
  const baseProductImg = document.getElementById('preview-base-product-img');
  
  const lblPlacement = document.getElementById('live-lbl-placement');
  const lblSize = document.getElementById('live-lbl-size');
  const lblColor = document.getElementById('live-lbl-color');
  const fileInput = document.getElementById('custom-artwork-file');
  const textBox = document.getElementById('custom-design-text-box');

  // Master Function: Jo strictly active tab ke hidden fields ko manage karega
  function enforceSingleTabProperties() {
    const mainOptionInput = document.getElementById('selected-design-option');
    const designValueInput = document.getElementById('selected-design-value');
    const designImageInput = document.getElementById('selected-design-image-url');
    const artworkNameInput = document.getElementById('uploaded-artwork-name');
    const customTextInput = document.getElementById('custom-design-text-val');

    let activeTab = document.querySelector('.design-tab-btn.active');
    if (!activeTab) return;

    let activeTabKey = activeTab.dataset.tabName ? activeTab.dataset.tabName.toLowerCase() : '';
    let displayTitle = activeTab.querySelector('span').textContent.trim();
    if (mainOptionInput) mainOptionInput.value = displayTitle;

    if (designImageInput) {
      designImageInput.removeAttribute('disabled');
    }

    if (activeTabKey === 'designs') {
      if (designValueInput) {
        designValueInput.removeAttribute('disabled');
        let activeCard = document.querySelector('.design-gallery-card.active');
        designValueInput.value = activeCard ? activeCard.dataset.designName : '';
      }
      if (artworkNameInput) { artworkNameInput.setAttribute('disabled', 'true'); artworkNameInput.value = ""; }
      if (customTextInput) { customTextInput.setAttribute('disabled', 'true'); customTextInput.value = ""; }
    } 
    else if (activeTabKey === 'artwork') {
      if (designValueInput) { designValueInput.setAttribute('disabled', 'true'); designValueInput.value = ""; }
      if (artworkNameInput) {
        artworkNameInput.removeAttribute('disabled');
        artworkNameInput.value = (fileInput && fileInput.files && fileInput.files[0]) ? fileInput.files[0].name : '';
      }
      if (customTextInput) { customTextInput.setAttribute('disabled', 'true'); customTextInput.value = ""; }
    } 
    else if (activeTabKey === 'text') {
      if (designValueInput) { designValueInput.setAttribute('disabled', 'true'); designValueInput.value = ""; }
      if (artworkNameInput) { artworkNameInput.setAttribute('disabled', 'true'); artworkNameInput.value = ""; }
      if (customTextInput) {
        customTextInput.removeAttribute('disabled');
        customTextInput.value = textBox ? textBox.value.trim() : '';
      }
    }
  }

  // ========================================================
  // 🧩 MASTER CANVAS GENERATOR: Shirt + Design ko merge karne ke liye
  // ========================================================
  function generateMergedMockupForCart() {
    return new Promise((resolve) => {
      if (!baseProductImg) return resolve(null);

      // Ek temporary canvas element create karna
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const shirtImg = new Image();
      shirtImg.crossOrigin = "anonymous"; // CORS issue protection
      shirtImg.src = baseProductImg.src;

      shirtImg.onload = function () {
        // Canvas size ko base shirt ke equal rakhna
        canvas.width = shirtImg.naturalWidth || 600;
        canvas.height = shirtImg.naturalHeight || 750;

        // 1. First layer draw karo: Plain T-Shirt Mockup
        ctx.drawImage(shirtImg, 0, 0, canvas.width, canvas.height);

        // 2. Second layer check karo: Kya koi design ya logo active hai?
        let activeLogoImg = overlayPlaceholder ? overlayPlaceholder.querySelector('img') : null;
        let selectedPlacement = lblPlacement ? lblPlacement.textContent.trim().toLowerCase() : 'front';

        // Placement ke according canvas par design coordinate settings
        let designX = canvas.width * 0.35;
        let designY = canvas.height * 0.22;
        let designW = canvas.width * 0.30;
        let designH = canvas.height * 0.30;

        if (selectedPlacement.includes('back')) {
          designX = canvas.width * 0.32; designY = canvas.height * 0.22; designW = canvas.width * 0.35;
        } else if (selectedPlacement.includes('left')) {
          designX = canvas.width * 0.58; designY = canvas.height * 0.20; designW = canvas.width * 0.15;
        } else if (selectedPlacement.includes('right')) {
          designX = canvas.width * 0.28; designY = canvas.height * 0.20; designW = canvas.width * 0.15;
        } else if (selectedPlacement.includes('sleeve')) {
          designX = canvas.width * 0.12; designY = canvas.height * 0.24; designW = canvas.width * 0.14;
        }

        if (activeLogoImg) {
          const logoImg = new Image();
          logoImg.crossOrigin = "anonymous";
          logoImg.src = activeLogoImg.src;
          logoImg.onload = function () {
            // Logo draw karo shirt ke exact upar
            ctx.drawImage(logoImg, designX, designY, designW, designW * (logoImg.naturalHeight / logoImg.naturalWidth));
            resolve(canvas.toDataURL('image/png'));
          };
          logoImg.onerror = () => resolve(shirtImg.src); // Fail hone par plain shirt bhej do
        } 
        // 3. Agar logo nahi hai, text active hai toh text draw karo
        else if (textBox && textBox.value.trim() !== "" && document.querySelector('.design-tab-btn[data-tab-name="text"]').classList.contains('active')) {
          ctx.font = `bold ${canvas.width * 0.035}px sans-serif`;
          ctx.fillStyle = "#000000";
          ctx.textAlign = "center";
          
          // White background card draw karna text ke piche (Design Preview look replica)
          ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
          ctx.fillRect(designX, designY, designW, canvas.height * 0.06);
          ctx.fillStyle = "#000000";
          ctx.lineWidth = 2;
          ctx.strokeRect(designX, designY, designW, canvas.height * 0.06);
          
          ctx.fillText(textBox.value.trim(), designX + (designW / 2), designY + (canvas.height * 0.04));
          resolve(canvas.toDataURL('image/png'));
        } else {
          resolve(shirtImg.src);
        }
      };
      shirtImg.onerror = () => resolve(baseProductImg.src);
    });
  }

  // --- Click Monitors & Handlers ---
  document.body.addEventListener('click', function(e) {
    const colorNode = e.target.closest('[data-color]') || e.target.closest('.color-swatch-item');
    if (colorNode) {
      let colorVal = colorNode.dataset.color || colorNode.getAttribute('data-color');
      if (colorVal) {
        if (lblColor && !colorVal.startsWith('#')) lblColor.textContent = colorVal.charAt(0).toUpperCase() + colorVal.slice(1);
        syncProductBaseImageWithVariant();
        setTimeout(enforceSingleTabProperties, 150);
      }
    }

    const sizeNode = e.target.closest('[data-size]') || e.target.closest('.size-swatch-item');
    if (sizeNode) {
      let sizeVal = sizeNode.dataset.size || sizeNode.getAttribute('data-size');
      if (lblSize && sizeVal) lblSize.textContent = sizeVal.trim();
    }

    const placementNode = e.target.closest('[data-placement]') || e.target.closest('.placement-swatch-item');
    if (placementNode) {
      let pVal = placementNode.dataset.placement || placementNode.getAttribute('data-placement');
      if (pVal) {
        if (lblPlacement) lblPlacement.textContent = pVal.trim();
        if (designOverlayContainer) {
          designOverlayContainer.className = "";
          designOverlayContainer.classList.add(`placement-${pVal.toLowerCase().replace(' ', '-')}`);
        }
        syncProductBaseImageWithVariant();
        setTimeout(enforceSingleTabProperties, 150);
      }
    }

    if (e.target.closest('.design-tab-btn') || e.target.closest('.design-gallery-card')) {
      setTimeout(() => { enforceSingleTabProperties(); syncGraphicsOverlayLayer(); }, 50);
    }
  });

  function syncProductBaseImageWithVariant() {
    if (!baseProductImg) return;
    let selectedColorText = lblColor ? lblColor.textContent.trim().toLowerCase() : '';
    let selectedPlacementText = lblPlacement ? lblPlacement.textContent.trim().toLowerCase() : 'front';

    let autoNode = document.querySelector(`.auto-color-url-node[data-color-key="${selectedColorText}"]`);
    let comboAltImg = document.querySelector(`img[alt*="${selectedColorText} ${selectedPlacementText}"], img[alt*="${selectedPlacementText} ${selectedColorText}"]`);
    let singleColorAltImg = document.querySelector(`img[alt="${selectedColorText}"], img[alt*="${selectedColorText} mockup"]`);
    let themeVariantImg = document.querySelector('.product__media img, .product-single__photos img, form[action*="/cart/add"] img');

    if (comboAltImg && comboAltImg.src) baseProductImg.src = comboAltImg.src;
    else if (autoNode && autoNode.dataset.imgSrc) baseProductImg.src = autoNode.dataset.imgSrc;
    else if (singleColorAltImg && singleColorAltImg.src) baseProductImg.src = singleColorAltImg.src;
    else if (themeVariantImg && themeVariantImg.src) baseProductImg.src = themeVariantImg.src;
  }

  function syncGraphicsOverlayLayer() {
    if (!overlayPlaceholder) return;
    overlayPlaceholder.innerHTML = ""; 
    let activeTab = document.querySelector('.design-tab-btn.active');
    let tabKey = activeTab ? activeTab.dataset.tabName.toLowerCase() : 'designs';

    if (tabKey === 'designs') {
      let activeCard = document.querySelector('.design-gallery-card.active');
if (activeCard && activeCard.dataset.designImage) {
let img = document.createElement('img'); img.src = activeCard.dataset.designImage;
overlayPlaceholder.appendChild(img);
}
}
else if (tabKey === 'artwork') {
if (fileInput && fileInput.files && fileInput.files[0]) {
let fileReader = new FileReader();
fileReader.onload = function (e) { let img = document.createElement('img'); img.src = e.target.result; overlayPlaceholder.appendChild(img); }
fileReader.readAsDataURL(fileInput.files[0]);
}
}
else if (tabKey === 'text') {
if (textBox && textBox.value.trim() !== "") {
let txtDiv = document.createElement('div'); txtDiv.className = "preview-text-render"; txtDiv.textContent = textBox.value.trim();
overlayPlaceholder.appendChild(txtDiv);
}
}
}
if (textBox) textBox.addEventListener('input', function() { enforceSingleTabProperties(); syncGraphicsOverlayLayer(); });
if (fileInput) fileInput.addEventListener('change', function() { enforceSingleTabProperties(); syncGraphicsOverlayLayer(); });
setTimeout(() => { syncProductBaseImageWithVariant(); enforceSingleTabProperties(); syncGraphicsOverlayLayer(); }, 800);
function refreshActiveCartSystemLayout() {
fetch(window.Shopify.routes.root + 'cart.js')
.then(res => res.json())
.then(cart => {
const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
const bubbleHTMLs = document.querySelectorAll('.cart-count-bubble');
bubbleHTMLs.forEach(bubble => {
bubble.textContent = cart.item_count;
if (cart.item_count === 0) bubble.classList.add('hidden');
else bubble.classList.remove('hidden');
});
if (cartDrawer) {
if (cart.item_count === 0) {
cartDrawer.removeAttribute('open'); cartDrawer.classList.add('is-empty');
} else { cartDrawer.classList.remove('is-empty'); }
}
});
}


document.addEventListener('cart:updated', function() { setTimeout(refreshActiveCartSystemLayout, 300); });
document.documentElement.addEventListener('cart:refresh', function() { setTimeout(refreshActiveCartSystemLayout, 300); });
// === FETCH INTERCEPTOR FOR REAL-TIME MERGE IMAGE INJECTION ===
const originalFetch = window.fetch;
window.fetch = async function (...args) {
let url = args[0];
let options = args[1] || {};
let urlString = (typeof url === 'string') ? url : (url instanceof Request ? url.url : '');
if (urlString.includes('/cart/add')) {
enforceSingleTabProperties();
// Submit dabte hi combined shirt + logo image base64 data create karna
const mainOptionInput = document.getElementById('selected-design-option');
let activeTab = document.querySelector('.design-tab-btn.active');
let activeTabKey = activeTab ? activeTab.dataset.tabName.toLowerCase() : '';

const mergedImageBase64 = activeTabKey === 'designs'
  ? null
  : await generateMergedMockupForCart();

if (options.body instanceof FormData) {
  if (mainOptionInput) {
    options.body.set('properties[Design Option]', mainOptionInput.value);
  }

  if (activeTabKey === 'designs') {
    options.body.delete('properties[_DesignImage]');
  } else if (mergedImageBase64) {
    options.body.set('properties[_DesignImage]', mergedImageBase64);
  }
if (activeTabKey === 'text') {
options.body.set('properties[Custom Text]', textBox ? textBox.value.trim() : '');
options.body.delete('properties[Selected Design]');
options.body.delete('properties[Uploaded Artwork]');
}
else if (activeTabKey === 'artwork') {
options.body.set('properties[Uploaded Artwork]', (fileInput && fileInput.files && fileInput.files[0]) ? fileInput.files[0].name : '');
options.body.delete('properties[Selected Design]');
options.body.delete('properties[Custom Text]');
}
else if (activeTabKey === 'designs') {
let activeCard = document.querySelector('.design-gallery-card.active');
options.body.set('properties[Selected Design]', activeCard ? activeCard.dataset.designName : '');
options.body.delete('properties[Uploaded Artwork]');
options.body.delete('properties[Custom Text]');
options.body.delete('properties[_DesignImage]');
}
let latestInstruction = document.getElementById('custom-instruction-hidden-val');
if (latestInstruction && latestInstruction.value.trim() !== "") {
options.body.set('properties[Additional Instructions]', latestInstruction.value.trim());
} else {
options.body.delete('properties[Additional Instructions]');
}
}
}
return originalFetch.apply(this, args).then(response => {
if (urlString.includes('/cart/add') && response.ok) {
setTimeout(() => {
refreshActiveCartSystemLayout();
const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
if (cartDrawer) {
cartDrawer.classList.remove('is-empty');
cartDrawer.setAttribute('open', '');
if (typeof cartDrawer.open === 'function') cartDrawer.open();
}
}, 300);
}
return response;
});
};
});



  // --- 🌟 VIEW MORE DESIGNS MODAL POPUP ENGINE DRIVER ---
  const popupModal = document.getElementById('master-designs-popup-modal');
  const openPopupBtn = document.getElementById('open-all-designs-popup-btn');
  const closePopupBtn = document.getElementById('close-designs-popup-modal');

  if (openPopupBtn && popupModal) {
    openPopupBtn.addEventListener('click', function() {
      popupModal.style.display = "flex";
    });
  }

  if (closePopupBtn && popupModal) {
    closePopupBtn.addEventListener('click', function() {
      popupModal.style.display = "none";
    });
    // Overlay area click control logic to close window
    popupModal.addEventListener('click', function(e) {
      if (e.target === popupModal) popupModal.style.display = "none";
    });
  }

  // Handle items click selections inside modal popup view elements
  document.querySelectorAll('.custom-popup-item').forEach(popupCard => {
    popupCard.addEventListener('click', function() {
      const selectedDesignName = this.getAttribute('data-design-name');
      
      // Popup item click hone par, ye pure store layout me sync state handle karega
      document.querySelectorAll('.design-gallery-card').forEach(card => {
        if (card.getAttribute('data-design-name') === selectedDesignName) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });

      // Automatically trigger your unified properties validation array sequence function 
      if (typeof enforceSingleTabProperties === 'function') enforceSingleTabProperties();
      if (typeof updateDesignSystemProperties === 'function') updateDesignSystemProperties();
      
      // Automatically close the popup window modal smoothly
      if (popupModal) popupModal.style.display = "none";
    });
  });



  // --- 📏 DYNAMIC SIZE GUIDE POPUP MODAL ENGINE ---
  const sizeModal = document.getElementById('size-guide-popup-modal');
  const openSizeBtn = document.getElementById('open-size-guide-modal-btn');
  const closeSizeBtn = document.getElementById('close-size-guide-modal');

  if (openSizeBtn && sizeModal) {
    openSizeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      sizeModal.style.display = "flex";
    });
  }

  if (closeSizeBtn && sizeModal) {
    closeSizeBtn.addEventListener('click', function() {
      sizeModal.style.display = "none";
    });
    
    // Background blank area click lock to close modal window smoothly
    sizeModal.addEventListener('click', function(e) {
      if (e.target === sizeModal) sizeModal.style.display = "none";
    });
  }

//   =====================
(function () {
  function initAdditionalInstructions() {
    const textarea = document.getElementById(
      'custom-additional-instructions-box'
    );

    const hidden = document.getElementById(
      'custom-instruction-hidden-val'
    );

    const counter = document.getElementById(
      'instruction-char-counter'
    );

    if (!textarea || !hidden) return;

    function syncValue() {
      hidden.value = textarea.value.trim();

      if (counter) {
        counter.textContent =
          `${textarea.value.length}/500 characters`;
      }
    }

    textarea.addEventListener('input', syncValue);

    const form = document.getElementById(hidden.getAttribute('form'));

    if (form) {
      form.addEventListener('submit', syncValue, true);
    }

    syncValue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAdditionalInstructions
    );
  } else {
    initAdditionalInstructions();
  }
})();